import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editPowerSupplyAvailability } from '@api/assets';

import { ESnackbarTypes } from '@enums/common';

import { ASSET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateEditPwrSupplyA11y = (id: string) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdatePowerSupplyAvailability,
		isLoading: isLoadingPowerSupplyAvailability,
	} = useMutation({
		mutationKey: [ASSET, id],
		mutationFn: editPowerSupplyAvailability,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedAsset,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([ASSET]);
		},
	});

	return { handleUpdatePowerSupplyAvailability, isLoadingPowerSupplyAvailability };
};
